// src/pages/equiposColaborativos/EquiposColaborativos.jsx
import React, { useState, useMemo } from 'react';
import "./equiposColaborativos.scss";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import { useSidebarState } from "../../components/sidebar/SidebarStateContext";
import scuData from '../../dataset_scu_pracom_andalucia.json';

// Generar datos ficticios de rondas y control horario desde Julio 2025 hasta Enero 2026
const generarDatosRondas = (vigilantes) => {
  const rondas = [];
  const meses = ['2025-07', '2025-08', '2025-09', '2025-10', '2025-11', '2025-12', '2026-01'];
  const ubicaciones = [
    'Entrada Principal', 'Zona A - Almacén', 'Zona B - Oficinas', 'Parking Subterráneo',
    'Azotea', 'Sala Servidores', 'Recepción', 'Control de Accesos', 'Perímetro Norte', 'Perímetro Sur'
  ];
  
  let idRonda = 1;
  meses.forEach(mes => {
    for (let dia = 1; dia <= 28; dia++) {
      const fecha = `${mes}-${String(dia).padStart(2, '0')}`;
      const numRondas = Math.floor(Math.random() * 5) + 3;
      
      for (let r = 0; r < numRondas; r++) {
        const hora = Math.floor(Math.random() * 24);
        const minutos = Math.floor(Math.random() * 60);
        const vigilante = vigilantes[Math.floor(Math.random() * vigilantes.length)];
        const ubicacion = ubicaciones[Math.floor(Math.random() * ubicaciones.length)];
        
        rondas.push({
          id: idRonda++,
          fecha,
          hora: `${String(hora).padStart(2, '0')}:${String(minutos).padStart(2, '0')}`,
          vigilante: vigilante.nombre_completo,
          vigilante_id: vigilante.user_id,
          ubicacion,
          estado: Math.random() > 0.05 ? 'completada' : 'incidencia',
          puntos_verificados: Math.floor(Math.random() * 5) + 5,
          observaciones: Math.random() > 0.8 ? 'Sin novedad' : null
        });
      }
    }
  });
  
  return rondas;
};

const generarDatosHorarios = (vigilantes) => {
  const registros = [];
  const meses = ['2025-07', '2025-08', '2025-09', '2025-10', '2025-11', '2025-12', '2026-01'];
  
  let idRegistro = 1;
  vigilantes.forEach(vigilante => {
    meses.forEach(mes => {
      for (let dia = 1; dia <= 28; dia++) {
        if (Math.random() > 0.15) { // 85% días trabajados
          const fecha = `${mes}-${String(dia).padStart(2, '0')}`;
          const turno = Math.random() > 0.5 ? 'mañana' : (Math.random() > 0.5 ? 'tarde' : 'noche');
          
          let horaEntrada, horaSalida;
          if (turno === 'mañana') {
            horaEntrada = `0${6 + Math.floor(Math.random() * 2)}:${String(Math.floor(Math.random() * 10)).padStart(2, '0')}`;
            horaSalida = `1${4 + Math.floor(Math.random() * 2)}:${String(Math.floor(Math.random() * 60)).padStart(2, '0')}`;
          } else if (turno === 'tarde') {
            horaEntrada = `1${4 + Math.floor(Math.random() * 2)}:${String(Math.floor(Math.random() * 10)).padStart(2, '0')}`;
            horaSalida = `2${2 + Math.floor(Math.random() * 2)}:${String(Math.floor(Math.random() * 60)).padStart(2, '0')}`;
          } else {
            horaEntrada = `2${2 + Math.floor(Math.random() * 2)}:${String(Math.floor(Math.random() * 10)).padStart(2, '0')}`;
            horaSalida = `0${6 + Math.floor(Math.random() * 2)}:${String(Math.floor(Math.random() * 60)).padStart(2, '0')}`;
          }
          
          registros.push({
            id: idRegistro++,
            fecha,
            vigilante_id: vigilante.user_id,
            vigilante: vigilante.nombre_completo,
            email: vigilante.email,
            turno,
            hora_entrada: horaEntrada,
            hora_salida: horaSalida,
            horas_trabajadas: 8 + Math.floor(Math.random() * 2),
            localizacion: `SERVICIO-${Math.floor(Math.random() * 50) + 1}`
          });
        }
      }
    });
  });
  
  return registros;
};

const generarEquiposColaborativos = (vigilantes) => {
  return [
    {
      id: 1,
      nombre: 'Equipo Seguridad Centro Comercial',
      descripcion: 'Coordinación de servicios en centros comerciales de Andalucía',
      miembros: vigilantes.slice(0, 12),
      color: '#4CAF50',
      proyectos: ['Proyecto CC Sevilla Plaza', 'Optimización Turnos Q4'],
      activo: true,
      fechaCreacion: '2025-07-15'
    },
    {
      id: 2,
      nombre: 'Equipo Oficinas Corporativas',
      descripcion: 'Gestión de seguridad en edificios de oficinas',
      miembros: vigilantes.slice(12, 24),
      color: '#2196F3',
      proyectos: ['Torre Empresarial Málaga', 'Edificio Institucional Córdoba'],
      activo: true,
      fechaCreacion: '2025-07-20'
    },
    {
      id: 3,
      nombre: 'Equipo Eventos Especiales',
      descripcion: 'Coordinación para eventos y ocasiones especiales',
      miembros: vigilantes.slice(24, 36),
      color: '#FF9800',
      proyectos: ['Feria de Abril 2026', 'Conciertos Navidad'],
      activo: true,
      fechaCreacion: '2025-08-05'
    },
    {
      id: 4,
      nombre: 'Equipo Formación y Desarrollo',
      descripcion: 'Capacitación continua del personal',
      miembros: vigilantes.slice(36, 48),
      color: '#9C27B0',
      proyectos: ['Plan Formación 2025-2026', 'Certificaciones'],
      activo: true,
      fechaCreacion: '2025-08-10'
    },
    {
      id: 5,
      nombre: 'Equipo Innovación Digital',
      descripcion: 'Implementación de nuevas tecnologías',
      miembros: vigilantes.slice(48, 60),
      color: '#E91E63',
      proyectos: ['Kit Digital', 'App Móvil v2'],
      activo: true,
      fechaCreacion: '2025-09-01'
    }
  ];
};

const generarTareasColaborativas = (vigilantes, equipos) => {
  return [
    {
      id: 1,
      titulo: 'Revisar protocolo de emergencias',
      descripcion: 'Actualizar documentación de protocolos para Q1 2026',
      asignadoA: [vigilantes[0], vigilantes[5], vigilantes[10]],
      estado: 'En progreso',
      prioridad: 'Alta',
      equipo: equipos[0].nombre,
      fechaLimite: '2026-01-31',
      progreso: 65
    },
    {
      id: 2,
      titulo: 'Coordinar turnos para Navidad',
      descripcion: 'Planificación de cuadrantes para periodo festivo',
      asignadoA: [vigilantes[12], vigilantes[15]],
      estado: 'Completada',
      prioridad: 'Alta',
      equipo: equipos[1].nombre,
      fechaLimite: '2025-12-15',
      progreso: 100
    },
    {
      id: 3,
      titulo: 'Documentar nuevos procedimientos',
      descripcion: 'Crear guías de usuario para nuevas funcionalidades',
      asignadoA: [vigilantes[48], vigilantes[50], vigilantes[52]],
      estado: 'En progreso',
      prioridad: 'Media',
      equipo: equipos[4].nombre,
      fechaLimite: '2026-02-15',
      progreso: 40
    },
    {
      id: 4,
      titulo: 'Preparar sesión formativa seguridad',
      descripcion: 'Formación en nuevos equipos de vigilancia',
      asignadoA: [vigilantes[36], vigilantes[38], vigilantes[40]],
      estado: 'Pendiente',
      prioridad: 'Media',
      equipo: equipos[3].nombre,
      fechaLimite: '2026-01-20',
      progreso: 0
    },
    {
      id: 5,
      titulo: 'Coordinar cobertura Feria de Abril',
      descripcion: 'Planificación anticipada del evento',
      asignadoA: [vigilantes[24], vigilantes[28], vigilantes[32]],
      estado: 'Pendiente',
      prioridad: 'Baja',
      equipo: equipos[2].nombre,
      fechaLimite: '2026-03-01',
      progreso: 10
    }
  ];
};

const generarRecursosCompartidos = (vigilantes) => {
  return [
    { id: 1, nombre: 'Manual Procedimientos 2025.pdf', tipo: 'Documento', compartidoPor: vigilantes[0], fecha: '2025-12-20', descargas: 45 },
    { id: 2, nombre: 'Template Cuadrantes Mensual.xlsx', tipo: 'Plantilla', compartidoPor: vigilantes[12], fecha: '2025-11-15', descargas: 32 },
    { id: 3, nombre: 'Video: Uso App Móvil', tipo: 'Video', compartidoPor: vigilantes[48], fecha: '2025-10-28', descargas: 67 },
    { id: 4, nombre: 'Protocolo Emergencias v3.docx', tipo: 'Documento', compartidoPor: vigilantes[5], fecha: '2025-09-10', descargas: 28 },
    { id: 5, nombre: 'Checklist Rondas.pdf', tipo: 'Documento', compartidoPor: vigilantes[24], fecha: '2025-08-22', descargas: 54 },
    { id: 6, nombre: 'Mapa Puntos Control.png', tipo: 'Imagen', compartidoPor: vigilantes[36], fecha: '2025-07-18', descargas: 41 }
  ];
};

const generarMensajesEquipo = (vigilantes) => {
  return [
    { id: 1, usuario: vigilantes[0], mensaje: '¿Quién puede cubrir el turno del viernes noche?', timestamp: '09:15', fecha: '2026-01-17', equipo: 'Equipo Seguridad Centro Comercial' },
    { id: 2, usuario: vigilantes[5], mensaje: 'Yo puedo, confirmo disponibilidad', timestamp: '09:22', fecha: '2026-01-17', equipo: 'Equipo Seguridad Centro Comercial' },
    { id: 3, usuario: vigilantes[12], mensaje: 'He subido el nuevo protocolo a Recursos', timestamp: '10:45', fecha: '2026-01-17', equipo: 'Equipo Oficinas Corporativas' },
    { id: 4, usuario: vigilantes[48], mensaje: 'La nueva versión de la app ya está disponible', timestamp: '11:30', fecha: '2026-01-16', equipo: 'Equipo Innovación Digital' },
    { id: 5, usuario: vigilantes[36], mensaje: 'Recordad la formación de mañana a las 10:00', timestamp: '16:00', fecha: '2026-01-15', equipo: 'Equipo Formación y Desarrollo' }
  ];
};

const EquiposColaborativos = () => {
  const { collapsed } = useSidebarState();
  const vigilantes = scuData.vigilantes;
  
  // Estados
  const [vistaActiva, setVistaActiva] = useState('equipos');
  const [equipoSeleccionado, setEquipoSeleccionado] = useState(null);
  const [filtroMes, setFiltroMes] = useState('2026-01');
  const [busquedaUsuario, setBusquedaUsuario] = useState('');
  const [mostrarCrearEquipo, setMostrarCrearEquipo] = useState(false);
  const [mostrarFlujoTrabajo, setMostrarFlujoTrabajo] = useState(false);
  
  // Datos generados
  const rondas = useMemo(() => generarDatosRondas(vigilantes), [vigilantes]);
  const horarios = useMemo(() => generarDatosHorarios(vigilantes), [vigilantes]);
  const equipos = useMemo(() => generarEquiposColaborativos(vigilantes), [vigilantes]);
  const tareas = useMemo(() => generarTareasColaborativas(vigilantes, equipos), [vigilantes, equipos]);
  const recursos = useMemo(() => generarRecursosCompartidos(vigilantes), [vigilantes]);
  const mensajes = useMemo(() => generarMensajesEquipo(vigilantes), [vigilantes]);
  
  // Filtrar usuarios
  const usuariosFiltrados = useMemo(() => {
    if (!busquedaUsuario) return vigilantes.slice(0, 40);
    return vigilantes.filter(v => 
      v.nombre_completo.toLowerCase().includes(busquedaUsuario.toLowerCase()) ||
      v.email.toLowerCase().includes(busquedaUsuario.toLowerCase())
    ).slice(0, 40);
  }, [vigilantes, busquedaUsuario]);
  
  // Estadísticas de rondas del mes seleccionado
  const estadisticasRondas = useMemo(() => {
    const rondasMes = rondas.filter(r => r.fecha.startsWith(filtroMes));
    return {
      total: rondasMes.length,
      completadas: rondasMes.filter(r => r.estado === 'completada').length,
      incidencias: rondasMes.filter(r => r.estado === 'incidencia').length,
      puntosVerificados: rondasMes.reduce((acc, r) => acc + r.puntos_verificados, 0)
    };
  }, [rondas, filtroMes]);
  
  // Estadísticas de horarios del mes seleccionado
  const estadisticasHorarios = useMemo(() => {
    const horariosMes = horarios.filter(h => h.fecha.startsWith(filtroMes));
    const horasTotales = horariosMes.reduce((acc, h) => acc + h.horas_trabajadas, 0);
    const vigilantesUnicos = [...new Set(horariosMes.map(h => h.vigilante_id))].length;
    
    return {
      registros: horariosMes.length,
      horasTotales,
      vigilantesActivos: vigilantesUnicos,
      mediaHorasDia: horariosMes.length > 0 ? (horasTotales / horariosMes.length).toFixed(1) : 0
    };
  }, [horarios, filtroMes]);
  
  const containerClass = collapsed ? "equiposContainer collapsed" : "equiposContainer";
  
  const getPrioridadColor = (prioridad) => {
    switch(prioridad) {
      case 'Alta': return '#F44336';
      case 'Media': return '#FF9800';
      case 'Baja': return '#4CAF50';
      default: return '#757575';
    }
  };
  
  const getEstadoColor = (estado) => {
    switch(estado) {
      case 'Completada': return '#4CAF50';
      case 'En progreso': return '#2196F3';
      case 'Pendiente': return '#FF9800';
      default: return '#757575';
    }
  };
  
  const getIconoTipo = (tipo) => {
    switch(tipo) {
      case 'Documento': return '📄';
      case 'Plantilla': return '📊';
      case 'Video': return '🎥';
      case 'Imagen': return '🖼️';
      default: return '📁';
    }
  };

  return (
    <div className="equiposColaborativos">
      <Sidebar />
      <div className={containerClass}>
        <Navbar />
        
        <div className="equipos-content">
          {/* HEADER */}
          <div className="header-equipos">
            <div className="logo-section">
              <h1>🤝 Colaboración en Equipos de Trabajo</h1>
              <p className="empresa-info">{scuData.empresa_nombre} - {scuData.total_vigilantes} usuarios</p>
            </div>
            <div className="stats-section">
              <div className="stat-card verde">
                <span className="stat-number">{equipos.length}</span>
                <span className="stat-label">Equipos Activos</span>
              </div>
              <div className="stat-card azul">
                <span className="stat-number">{tareas.filter(t => t.estado === 'En progreso').length}</span>
                <span className="stat-label">Tareas En Curso</span>
              </div>
              <div className="stat-card morado">
                <span className="stat-number">{recursos.length}</span>
                <span className="stat-label">Recursos Compartidos</span>
              </div>
            </div>
          </div>
          
          {/* NAVEGACIÓN POR VISTAS */}
          <div className="navegacion-vistas">
            <button 
              className={vistaActiva === 'equipos' ? 'activo' : ''} 
              onClick={() => setVistaActiva('equipos')}
            >
              👨‍👩‍👧‍👦 Equipos Colaborativos
            </button>
            <button 
              className={vistaActiva === 'rondas' ? 'activo' : ''} 
              onClick={() => setVistaActiva('rondas')}
            >
              🔄 Control de Rondas
            </button>
            <button 
              className={vistaActiva === 'horarios' ? 'activo' : ''} 
              onClick={() => setVistaActiva('horarios')}
            >
              ⏰ Control Horario
            </button>
            <button 
              className={vistaActiva === 'recursos' ? 'activo' : ''} 
              onClick={() => setVistaActiva('recursos')}
            >
              📚 Recursos Compartidos
            </button>
            <button 
              className={vistaActiva === 'flujos' ? 'activo' : ''} 
              onClick={() => setVistaActiva('flujos')}
            >
              ⚙️ Flujos de Trabajo
            </button>
          </div>
          
          {/* SELECTOR DE MES */}
          <div className="selector-mes">
            <label>📅 Periodo:</label>
            <select value={filtroMes} onChange={(e) => setFiltroMes(e.target.value)}>
              <option value="2026-01">Enero 2026</option>
              <option value="2025-12">Diciembre 2025</option>
              <option value="2025-11">Noviembre 2025</option>
              <option value="2025-10">Octubre 2025</option>
              <option value="2025-09">Septiembre 2025</option>
              <option value="2025-08">Agosto 2025</option>
              <option value="2025-07">Julio 2025</option>
            </select>
          </div>
          
          {/* CONTENIDO PRINCIPAL */}
          <div className="contenido-principal">
            {/* PANEL IZQUIERDO: USUARIOS */}
            <div className="panel-izquierdo">
              <div className="seccion-usuarios">
                <h2>👥 Usuarios Activos</h2>
                <div className="filtros-usuarios">
                  <input 
                    type="text" 
                    placeholder="🔍 Buscar usuario..." 
                    className="input-buscar"
                    value={busquedaUsuario}
                    onChange={(e) => setBusquedaUsuario(e.target.value)}
                  />
                </div>
                <div className="lista-usuarios">
                  {usuariosFiltrados.map((usuario, index) => (
                    <div 
                      key={usuario.user_id}
                      className="usuario-item"
                    >
                      <div className="usuario-avatar">
                        {usuario.nombre?.charAt(0)}{usuario.apellido1?.charAt(0)}
                      </div>
                      <div className="usuario-info">
                        <span className="usuario-nombre">{usuario.nombre_completo}</span>
                        <span className="usuario-email">{usuario.email}</span>
                      </div>
                      <div className={`usuario-estado ${index % 3 === 0 ? 'online' : 'offline'}`}></div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            
            {/* PANEL CENTRAL */}
            <div className="panel-central">
              {/* VISTA: EQUIPOS COLABORATIVOS */}
              {vistaActiva === 'equipos' && (
                <>
                  <div className="seccion-equipos">
                    <div className="seccion-header">
                      <h2>👨‍👩‍👧‍👦 Gestión de Equipos Colaborativos</h2>
                      <button className="btn-crear" onClick={() => setMostrarCrearEquipo(true)}>
                        ➕ Crear Equipo
                      </button>
                    </div>
                    <div className="grid-equipos">
                      {equipos.map(equipo => (
                        <div 
                          key={equipo.id}
                          className={`equipo-card ${equipoSeleccionado?.id === equipo.id ? 'activo' : ''}`}
                          style={{ borderLeftColor: equipo.color }}
                          onClick={() => setEquipoSeleccionado(equipo)}
                        >
                          <div className="equipo-header">
                            <h3>{equipo.nombre}</h3>
                            <span className="badge-estado activo">🟢 Activo</span>
                          </div>
                          <p className="equipo-descripcion">{equipo.descripcion}</p>
                          <div className="equipo-stats">
                            <span>👥 {equipo.miembros.length} miembros</span>
                            <span>📁 {equipo.proyectos.length} proyectos</span>
                          </div>
                          <div className="equipo-fecha">
                            <span>📅 Creado: {equipo.fechaCreacion}</span>
                          </div>
                          <div className="equipo-proyectos">
                            {equipo.proyectos.map((proyecto, idx) => (
                              <span key={idx} className="tag-proyecto">{proyecto}</span>
                            ))}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                  
                  {/* TAREAS COLABORATIVAS */}
                  <div className="seccion-tareas">
                    <div className="seccion-header">
                      <h2>✅ Tareas Colaborativas del Equipo</h2>
                      <button className="btn-nueva-tarea">➕ Nueva Tarea</button>
                    </div>
                    <div className="lista-tareas">
                      {tareas.map(tarea => (
                        <div key={tarea.id} className="tarea-item">
                          <div className="tarea-checkbox">
                            <input 
                              type="checkbox" 
                              checked={tarea.estado === 'Completada'}
                              readOnly
                            />
                          </div>
                          <div className="tarea-contenido">
                            <div className="tarea-header">
                              <span className="tarea-titulo">{tarea.titulo}</span>
                              <span 
                                className="tarea-prioridad" 
                                style={{ backgroundColor: getPrioridadColor(tarea.prioridad) }}
                              >
                                {tarea.prioridad}
                              </span>
                            </div>
                            <p className="tarea-descripcion">{tarea.descripcion}</p>
                            <div className="tarea-meta">
                              <span className="tarea-equipo">🏷️ {tarea.equipo}</span>
                              <span 
                                className="tarea-estado"
                                style={{ color: getEstadoColor(tarea.estado) }}
                              >
                                ● {tarea.estado}
                              </span>
                              <span className="tarea-fecha">📅 {tarea.fechaLimite}</span>
                            </div>
                            <div className="tarea-progreso">
                              <div className="progreso-bar">
                                <div 
                                  className="progreso-fill" 
                                  style={{ width: `${tarea.progreso}%`, backgroundColor: getEstadoColor(tarea.estado) }}
                                ></div>
                              </div>
                              <span className="progreso-texto">{tarea.progreso}%</span>
                            </div>
                            <div className="tarea-asignados">
                              {tarea.asignadoA.map((usuario, idx) => (
                                <div key={idx} className="avatar-pequeno" title={usuario.nombre_completo}>
                                  {usuario.nombre?.charAt(0)}{usuario.apellido1?.charAt(0)}
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </>
              )}
              
              {/* VISTA: CONTROL DE RONDAS */}
              {vistaActiva === 'rondas' && (
                <div className="seccion-rondas">
                  <div className="seccion-header">
                    <h2>🔄 Control de Rondas - {filtroMes}</h2>
                  </div>
                  
                  <div className="stats-rondas">
                    <div className="stat-box">
                      <span className="stat-valor">{estadisticasRondas.total}</span>
                      <span className="stat-etiqueta">Total Rondas</span>
                    </div>
                    <div className="stat-box verde">
                      <span className="stat-valor">{estadisticasRondas.completadas}</span>
                      <span className="stat-etiqueta">Completadas</span>
                    </div>
                    <div className="stat-box rojo">
                      <span className="stat-valor">{estadisticasRondas.incidencias}</span>
                      <span className="stat-etiqueta">Incidencias</span>
                    </div>
                    <div className="stat-box azul">
                      <span className="stat-valor">{estadisticasRondas.puntosVerificados}</span>
                      <span className="stat-etiqueta">Puntos Verificados</span>
                    </div>
                  </div>
                  
                  <div className="tabla-rondas">
                    <table>
                      <thead>
                        <tr>
                          <th>Fecha</th>
                          <th>Hora</th>
                          <th>Vigilante</th>
                          <th>Ubicación</th>
                          <th>Puntos</th>
                          <th>Estado</th>
                        </tr>
                      </thead>
                      <tbody>
                        {rondas
                          .filter(r => r.fecha.startsWith(filtroMes))
                          .slice(0, 50)
                          .map(ronda => (
                            <tr key={ronda.id}>
                              <td>{ronda.fecha}</td>
                              <td>{ronda.hora}</td>
                              <td>{ronda.vigilante}</td>
                              <td>{ronda.ubicacion}</td>
                              <td>{ronda.puntos_verificados}</td>
                              <td>
                                <span className={`estado-badge ${ronda.estado}`}>
                                  {ronda.estado === 'completada' ? '✅' : '⚠️'} {ronda.estado}
                                </span>
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
              
              {/* VISTA: CONTROL HORARIO */}
              {vistaActiva === 'horarios' && (
                <div className="seccion-horarios">
                  <div className="seccion-header">
                    <h2>⏰ Control Horario - {filtroMes}</h2>
                  </div>
                  
                  <div className="stats-horarios">
                    <div className="stat-box">
                      <span className="stat-valor">{estadisticasHorarios.registros}</span>
                      <span className="stat-etiqueta">Registros</span>
                    </div>
                    <div className="stat-box azul">
                      <span className="stat-valor">{estadisticasHorarios.horasTotales}</span>
                      <span className="stat-etiqueta">Horas Totales</span>
                    </div>
                    <div className="stat-box verde">
                      <span className="stat-valor">{estadisticasHorarios.vigilantesActivos}</span>
                      <span className="stat-etiqueta">Vigilantes Activos</span>
                    </div>
                    <div className="stat-box morado">
                      <span className="stat-valor">{estadisticasHorarios.mediaHorasDia}h</span>
                      <span className="stat-etiqueta">Media/Día</span>
                    </div>
                  </div>
                  
                  <div className="tabla-horarios">
                    <table>
                      <thead>
                        <tr>
                          <th>Fecha</th>
                          <th>Vigilante</th>
                          <th>Turno</th>
                          <th>Entrada</th>
                          <th>Salida</th>
                          <th>Horas</th>
                          <th>Localización</th>
                        </tr>
                      </thead>
                      <tbody>
                        {horarios
                          .filter(h => h.fecha.startsWith(filtroMes))
                          .slice(0, 50)
                          .map(registro => (
                            <tr key={registro.id}>
                              <td>{registro.fecha}</td>
                              <td>{registro.vigilante}</td>
                              <td>
                                <span className={`turno-badge ${registro.turno}`}>
                                  {registro.turno === 'mañana' ? '🌅' : registro.turno === 'tarde' ? '🌇' : '🌙'} {registro.turno}
                                </span>
                              </td>
                              <td>{registro.hora_entrada}</td>
                              <td>{registro.hora_salida}</td>
                              <td>{registro.horas_trabajadas}h</td>
                              <td>{registro.localizacion}</td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
              
              {/* VISTA: RECURSOS COMPARTIDOS */}
              {vistaActiva === 'recursos' && (
                <div className="seccion-recursos">
                  <div className="seccion-header">
                    <h2>📚 Recursos Compartidos</h2>
                    <button className="btn-compartir">📤 Compartir Recurso</button>
                  </div>
                  <p className="descripcion-recursos">
                    Base de conocimiento compartida para facilitar la colaboración entre equipos.
                    Documentos, plantillas y recursos accesibles para todos los miembros.
                  </p>
                  <div className="lista-recursos">
                    {recursos.map(recurso => (
                      <div key={recurso.id} className="recurso-item">
                        <div className="recurso-icono">{getIconoTipo(recurso.tipo)}</div>
                        <div className="recurso-info">
                          <span className="recurso-nombre">{recurso.nombre}</span>
                          <span className="recurso-meta">
                            Por {recurso.compartidoPor.nombre_completo} • {recurso.fecha}
                          </span>
                        </div>
                        <div className="recurso-acciones">
                          <span className="recurso-descargas">⬇️ {recurso.descargas}</span>
                          <button className="btn-descargar">Descargar</button>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
              
              {/* VISTA: FLUJOS DE TRABAJO */}
              {vistaActiva === 'flujos' && (
                <div className="seccion-flujos">
                  <div className="seccion-header">
                    <h2>⚙️ Configuración de Flujos de Trabajo</h2>
                  </div>
                  <p className="descripcion-flujos">
                    Personaliza y configura los flujos de trabajo para optimizar la colaboración
                    y automatizar procesos repetitivos.
                  </p>
                  
                  <div className="flujos-grid">
                    <div className="flujo-card">
                      <h3>📝 Asignación de Tareas</h3>
                      <p>Configura cómo se asignan las tareas a los miembros del equipo</p>
                      <div className="flujo-opciones">
                        <label>Método de asignación:</label>
                        <select>
                          <option>Asignación automática por disponibilidad</option>
                          <option>Asignación manual por supervisor</option>
                          <option>Round-robin entre miembros</option>
                        </select>
                      </div>
                      <div className="flujo-estado activo">✅ Activo</div>
                    </div>
                    
                    <div className="flujo-card">
                      <h3>✅ Aprobación de Cambios</h3>
                      <p>Define quién debe aprobar cambios en cuadrantes y turnos</p>
                      <div className="flujo-opciones">
                        <label>Nivel de aprobación:</label>
                        <select>
                          <option>Requiere supervisor</option>
                          <option>Aprobación automática</option>
                          <option>Doble aprobación</option>
                        </select>
                      </div>
                      <div className="flujo-estado activo">✅ Activo</div>
                    </div>
                    
                    <div className="flujo-card">
                      <h3>🔔 Notificaciones</h3>
                      <p>Configura cuándo y cómo recibir notificaciones</p>
                      <div className="flujo-opciones">
                        <label>Frecuencia:</label>
                        <select>
                          <option>Tiempo real</option>
                          <option>Resumen cada hora</option>
                          <option>Resumen diario</option>
                        </select>
                      </div>
                      <div className="flujo-estado activo">✅ Activo</div>
                    </div>
                    
                    <div className="flujo-card">
                      <h3>📊 Informes Automáticos</h3>
                      <p>Genera informes de rendimiento automáticamente</p>
                      <div className="flujo-opciones">
                        <label>Periodicidad:</label>
                        <select>
                          <option>Semanal</option>
                          <option>Quincenal</option>
                          <option>Mensual</option>
                        </select>
                      </div>
                      <div className="flujo-estado activo">✅ Activo</div>
                    </div>
                    
                    <div className="flujo-card">
                      <h3>🔄 Sincronización Externa</h3>
                      <p>Sincroniza datos con sistemas externos (Freematica)</p>
                      <div className="flujo-opciones">
                        <label>Intervalo:</label>
                        <select>
                          <option>Cada 15 minutos</option>
                          <option>Cada hora</option>
                          <option>Manual</option>
                        </select>
                      </div>
                      <div className="flujo-estado activo">✅ Activo</div>
                    </div>
                    
                    <div className="flujo-card">
                      <h3>💡 Sugerencias IA</h3>
                      <p>Recibe sugerencias inteligentes para optimización</p>
                      <div className="flujo-opciones">
                        <label>Ámbito:</label>
                        <select>
                          <option>Cuadrantes y turnos</option>
                          <option>Asignación de recursos</option>
                          <option>Todo</option>
                        </select>
                      </div>
                      <div className="flujo-estado inactivo">⚫ Inactivo</div>
                    </div>
                  </div>
                  
                  <div className="acciones-flujos">
                    <button className="btn-guardar-flujos">💾 Guardar Configuración</button>
                  </div>
                </div>
              )}
            </div>
            
            {/* PANEL DERECHO: HERRAMIENTAS */}
            <div className="panel-derecho">
              {/* INFO EQUIPO SELECCIONADO */}
              {equipoSeleccionado && vistaActiva === 'equipos' && (
                <div className="info-equipo-activo">
                  <h3 style={{ color: equipoSeleccionado.color }}>{equipoSeleccionado.nombre}</h3>
                  <p>{equipoSeleccionado.descripcion}</p>
                  
                  <div className="miembros-equipo">
                    <h4>Miembros ({equipoSeleccionado.miembros.length})</h4>
                    <div className="lista-miembros">
                      {equipoSeleccionado.miembros.slice(0, 8).map(miembro => (
                        <div key={miembro.user_id} className="miembro-mini">
                          <div className="avatar-mini">
                            {miembro.nombre?.charAt(0)}{miembro.apellido1?.charAt(0)}
                          </div>
                          <span>{miembro.nombre} {miembro.apellido1}</span>
                        </div>
                      ))}
                      {equipoSeleccionado.miembros.length > 8 && (
                        <span className="mas-miembros">+{equipoSeleccionado.miembros.length - 8} más</span>
                      )}
                    </div>
                    <button className="btn-agregar-miembro">➕ Agregar miembro</button>
                  </div>
                </div>
              )}
              
              {/* CHAT DEL EQUIPO */}
              <div className="herramienta-comunicacion">
                <h4>💬 Chat del Equipo</h4>
                <div className="chat-mensajes">
                  {mensajes.map(mensaje => (
                    <div key={mensaje.id} className="mensaje-item">
                      <div className="mensaje-avatar">
                        {mensaje.usuario.nombre?.charAt(0)}{mensaje.usuario.apellido1?.charAt(0)}
                      </div>
                      <div className="mensaje-contenido">
                        <div className="mensaje-header">
                          <span className="mensaje-usuario">{mensaje.usuario.nombre} {mensaje.usuario.apellido1}</span>
                          <span className="mensaje-timestamp">{mensaje.timestamp}</span>
                        </div>
                        <p className="mensaje-texto">{mensaje.mensaje}</p>
                        <span className="mensaje-equipo">{mensaje.equipo}</span>
                      </div>
                    </div>
                  ))}
                </div>
                <div className="chat-input">
                  <input type="text" placeholder="Escribe un mensaje..." />
                  <button>📨</button>
                </div>
              </div>
              
              {/* TABLERO DE IDEACIÓN */}
              <div className="herramienta-ideacion">
                <h4>💡 Ideación y Resolución de Problemas</h4>
                <div className="ideas-tablero">
                  <div className="idea-card">
                    <div className="idea-header">
                      <span>💡</span>
                      <span className="idea-votos">👍 15</span>
                    </div>
                    <p>Implementar rotación automática de turnos</p>
                    <span className="idea-autor">- {vigilantes[10].nombre_completo}</span>
                  </div>
                  <div className="idea-card">
                    <div className="idea-header">
                      <span>🔧</span>
                      <span className="idea-votos">👍 8</span>
                    </div>
                    <p>Mejorar sistema de alertas en tiempo real</p>
                    <span className="idea-autor">- {vigilantes[25].nombre_completo}</span>
                  </div>
                  <div className="idea-card problema">
                    <div className="idea-header">
                      <span>⚠️</span>
                      <span className="idea-estado">En resolución</span>
                    </div>
                    <p>Optimizar carga de cuadrantes grandes</p>
                    <span className="idea-autor">- {vigilantes[5].nombre_completo}</span>
                  </div>
                </div>
                <button className="btn-nueva-idea">➕ Nueva idea/problema</button>
              </div>
            </div>
          </div>
        </div>
        
        {/* MODAL CREAR EQUIPO */}
        {mostrarCrearEquipo && (
          <div className="modal-overlay" onClick={() => setMostrarCrearEquipo(false)}>
            <div className="modal-crear-equipo" onClick={(e) => e.stopPropagation()}>
              <div className="modal-header">
                <h3>Crear Nuevo Equipo Colaborativo</h3>
                <button onClick={() => setMostrarCrearEquipo(false)}>✕</button>
              </div>
              <div className="modal-body">
                <div className="form-group">
                  <label>Nombre del equipo</label>
                  <input type="text" placeholder="Ej: Equipo Coordinación Sur" />
                </div>
                <div className="form-group">
                  <label>Descripción</label>
                  <textarea placeholder="Describe el propósito y objetivos del equipo..."></textarea>
                </div>
                <div className="form-group">
                  <label>Color identificativo</label>
                  <div className="colores-selector">
                    <div className="color-option" style={{ backgroundColor: '#4CAF50' }}></div>
                    <div className="color-option" style={{ backgroundColor: '#2196F3' }}></div>
                    <div className="color-option" style={{ backgroundColor: '#FF9800' }}></div>
                    <div className="color-option" style={{ backgroundColor: '#9C27B0' }}></div>
                    <div className="color-option" style={{ backgroundColor: '#F44336' }}></div>
                    <div className="color-option" style={{ backgroundColor: '#E91E63' }}></div>
                  </div>
                </div>
                <div className="form-group">
                  <label>Proyectos iniciales</label>
                  <input type="text" placeholder="Separados por comas..." />
                </div>
              </div>
              <div className="modal-footer">
                <button className="btn-cancelar" onClick={() => setMostrarCrearEquipo(false)}>Cancelar</button>
                <button className="btn-guardar" onClick={() => setMostrarCrearEquipo(false)}>✅ Crear Equipo</button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default EquiposColaborativos;
